export const SAVE_USER_INFO = 'user/SAVE_USER_INFO';
export const GET_FETCHUSER = 'GET_FETCHUSER';
